import { connect } from 'react-redux';
import { getPaginationPage } from 'shared/components/Paginator';
import featureEnabled from 'shared/helper/feature';
import { getLink } from 'shared/helper/link-helper';
import withRouter from 'shared/helper/with-router';
import { searchDigitalOrders } from 'researcher/digital-orders/actions';
import { getDigitalPurchases, getDigitalTranslationsEnabled, getTranslationAccessType } from 'researcher/digital-orders/reducer';
import DigitalTranslations from './DigitalTranslations';
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var application = _ref.application,
    digitalOrders = _ref.digitalOrders,
    user = _ref.user;
  var location = _ref2.location;
  return {
    accessType: getTranslationAccessType({
      digitalOrders: digitalOrders
    }),
    allowsDigitalTranslations: application.allowsDigitalTranslations,
    digitalPurchases: getDigitalPurchases({
      digitalOrders: digitalOrders
    }),
    digitalTranslationsEnabled: getDigitalTranslationsEnabled({
      digitalOrders: digitalOrders
    }),
    digitalTranslationsSurveyUrl: getLink({
      application: application,
      linkName: 'digitalTranslationsSurvey'
    }),
    displayDigitalTranslationsResults: digitalOrders.numberOfUsesAvailable > 0 || digitalOrders.hasUploadedDigitalTranslation,
    location: location,
    fileIdentity: digitalOrders.fileIdentity,
    numberOfUsesAvailable: digitalOrders.numberOfUsesAvailable,
    hasAvailableDigitalTranslationPurchases: digitalOrders.availableDigitalTranslationPurchases.length > 0,
    page: getPaginationPage({
      location: location
    }),
    status: digitalOrders.status,
    uuid: user.identity,
    wordCountExceeded: digitalOrders.wordCountExceeded,
    isCurieLaunched: featureEnabled('curie_is_launched')
  };
};
var mapDispatchToProps = {
  searchDigitalOrders: searchDigitalOrders
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DigitalTranslations));